// @flow
/** @jsx h */
import { ComponentChildren, h, Fragment } from 'preact';
import style from './style.css';
import { useWindowDimension } from '../../../utils/useWindowDimension';
import { useEffect, useState } from 'preact/hooks';

const Overlay_Height_Percentage = 0.75;

type Props = {
  handleCloseOverlay: Function,
  showOverlay: Boolean,
  overlaySizeClassName:
    | 'overlay-wd-small'
    | 'overlay-wd-medium'
    | 'overlay-wd-large',
  children: ComponentChildren,
};

const OverlayScreen = ({
  handleCloseOverlay,
  showOverlay,
  overlaySizeClassName,
  children,
  maxOverlayHeight,
}: Props) => {
  const [dimension] = useWindowDimension();
  const [width, height] = dimension;
  const [overlayHeight, setOverLayHeight] = useState(
    height * Overlay_Height_Percentage,
  );

  useEffect(() => {
    setOverLayHeight(height * Overlay_Height_Percentage);
  }, [height]);

  return (
    <Fragment>
      {showOverlay && <div className={style.overlayBackdrop} />}
      <div
        style={{
          maxHeight:
            overlayHeight < 200
              ? 200
              : maxOverlayHeight
              ? maxOverlayHeight
              : overlayHeight,
        }}
        className={`${style.overlayContainer} ${
          showOverlay ? style.modelSlideIn : ''
        } ${style[overlaySizeClassName]}`}>
        <div
          onClick={handleCloseOverlay}
          className={style.closeButtonContainer}>
          <span className={`material-icons ${style.closeIcon}`}>close</span>
        </div>
        <div className={style.cardContainerWrapper}>
          <div
            style={{
              transform: showOverlay ? 'translateY(0)' : 'translateY(100%)',
              display: showOverlay ? 'block' : 'none',
            }}
            className={style.cardContainer}
            showOverlay={showOverlay}>
            {children}
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default OverlayScreen;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/overlayScreen/index.js